import {
  COLUNAS_DEFAULT_MODULE_FINANCEIRO,
  COLUNAS_DEFAULT_MODULE_PARAMETRIZACAO,
  COLUNAS_DEFAULT_MODULE_PARCEIRO,
  COLUNAS_DEFAULT_MODULE_PRODUTO,
  COLUNAS_DEFAULT_MODULE_SYSADMIN,
  COLUNAS_DEFAULT_MODULE_SYSADMIN_PRECIFICACAO,
  COLUNAS_DEFAULT_MODULE_SYSADMIN_REPORT_FINANCEIRO,
  COLUNAS_DEFAULT_MODULE_VENDAS
} from '@app/shared/utils/colunas/const';
import { IColunasSettingsUser } from '../validar_settings_user';

export const COLUNAS_DEFAULT_PROJETO = [
  ...COLUNAS_DEFAULT_MODULE_PARCEIRO,
  ...COLUNAS_DEFAULT_MODULE_FINANCEIRO,
  ...COLUNAS_DEFAULT_MODULE_VENDAS,
  ...COLUNAS_DEFAULT_MODULE_PRODUTO,
  ...COLUNAS_DEFAULT_MODULE_PARAMETRIZACAO,
  ...COLUNAS_DEFAULT_MODULE_FINANCEIRO,
] as IColunasSettingsUser[];

export const COLUNAS_DEFAULT_SYSDAMIN = [
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN,
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN_PRECIFICACAO,
  ...COLUNAS_DEFAULT_MODULE_SYSADMIN_REPORT_FINANCEIRO
]
